import { OverlayContainer } from '@angular/cdk/overlay';
import {
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { EncryptorService } from '../../Services/encryptor.service';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.css'],
    standalone: false
})
export class MaintenanceComponent implements OnInit {
    constructor(
        private overlay: OverlayContainer,
        private title: Title,
        private encryptorService: EncryptorService
    ) {}

    notFound: string = '/assets/img/cheems.png';
    logos: string = '/assets/img/logos.png';
    darkMode: boolean = true;
    defaultColor: boolean = true;

    themeKey = 'THEME';
    colorThemeKey = 'THEME-COLOR';

    @HostBinding('class') className = '';

    pageTitle: string = 'SCEU :: Servicio Temporalmente No Disponible';
    production: boolean = environment.production;
    check: boolean = environment.check;

    @Input() robot: boolean = false;
    @Output() onNoRobot: EventEmitter<any> = new EventEmitter();
    @ViewChild('captcha') captcha: RecaptchaComponent;
    siteKey: string = environment.recaptcha.siteKey;

    ngOnInit(): void {
        this.checkTheme();
        this.setTitle();
    }

    setTheme(darkMode: boolean) {
        const darkClassName = 'darkMode';
        const darkDevClassName = 'darkMode-dev';
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';
        const lightGreenClassName = 'lightMode-check';

        this.className = this.production
            ? darkMode
                ? darkClassName
                : lightClassName
            : this.check
            ? lightGreenClassName
            : darkDevClassName;

        localStorage.setItem(
            this.themeKey,
            this.encryptorService.aesEncrypt(this.className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(
                darkClassName,
                lightblueClassName,
                lightRedClassName,
                darkDevClassName
            );

        if (!this.production) {
            this.overlay.getContainerElement().classList.add(darkDevClassName);
            this.logos = '/assets/img/logos_white.png';
        } else if (darkMode) {
            this.overlay.getContainerElement().classList.add(darkClassName);
            this.logos = '/assets/img/logos_white.png';
        } else {
            this.checkColorLightTheme();
            this.logos = '/assets/img/logos.png';
        }
    }

    setColorLightTheme(defaultColor: boolean) {
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';

        const redClassName = 'red';
        const blueClassName = 'blue';

        this.className = defaultColor ? lightblueClassName : lightRedClassName;

        const className = defaultColor ? blueClassName : redClassName;

        localStorage.setItem(
            this.colorThemeKey,
            this.encryptorService.aesEncrypt(className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(lightblueClassName, lightRedClassName);

        if (defaultColor) {
            this.overlay
                .getContainerElement()
                .classList.add(lightblueClassName);
        } else {
            this.overlay.getContainerElement().classList.add(lightRedClassName);
        }
    }

    checkTheme() {
        const classStoraged = localStorage.getItem(this.themeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const darkMode = className == 'darkMode';

        this.setTheme(darkMode);

        this.darkMode = darkMode;
    }

    checkColorLightTheme() {
        const redClassName = 'red';

        const classStoraged = localStorage.getItem(this.colorThemeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const defaultColor = className != redClassName;

        this.setColorLightTheme(defaultColor);

        this.defaultColor = defaultColor;
    }

    setTitle() {
        this.title.setTitle(this.pageTitle);
    }

    resolved(event: any) {
        if (event) {
            this.onNoRobot.emit(event);
        }
    }
}
